const generateTestId = (label = '') => {
  if (label === '') {
    throw new Error('Label is required');
  }

  return `cash-checkout-${label}`;
};

export default generateTestId;
